import React from 'react'

export const ADMIN_NAV_TITLE = (
  <span>
    Second Step<sup>®</sup> Leader Dashboard
  </span>
)

export const DASHBOARD_NAV_TITLE = (
  <span>
    Second Step<sup>®</sup> Programs
  </span>
)
